import { AnimatedSection } from "@/components/shared/AnimatedSection";

interface Quote {
  label: string;
  text: string;
  person: string;
  role: string;
}

const QUOTES: Quote[] = [
  {
    label: "Energizing & motivating",
    text: "Verónica has a rare combination of design instinct and technical curiosity. She brings energy to every project and somehow makes everyone around her better. Working with her was one of the highlights of my career.",
    person: "Joel Monteon",
    role: "Staff Product Designer, MiSalud AI — was Verónica's mentor",
  },
  {
    label: "Versatile & invaluable",
    text: "I've worked with a lot of designers. Verónica is one of the few who can move seamlessly between strategy and execution — she'll facilitate a stakeholder workshop in the morning and ship polished components by EOD. Truly invaluable.",
    person: "Justo R. Garcia",
    role: "Product Design Leader — managed Verónica directly",
  },
  {
    label: "Top-notch attention to detail",
    text: "Verónica's attention to detail is exceptional — and I mean that as an engineer. She thinks about edge cases, accessibility, and implementation constraints before handing anything off. Working with her made our team's output significantly better.",
    person: "Rick Ross",
    role: "Director of Engineering, Vox Media",
  },
];

/**
 * Three peer quote cards styled like Anjali Rajeev's portfolio.
 * Label sits above the quote. Cards lift on hover.
 */
export function PeerQuotes() {
  return (
    <section className="py-16 px-6 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {QUOTES.map((q, i) => (
            <AnimatedSection key={q.person} delay={i * 80}>
              <div className="bg-white border border-[#E2E8F0] rounded-2xl p-6 h-full flex flex-col gap-4 hover:-translate-y-1 hover:shadow-md transition-all duration-300">
                {/* Label chip */}
                <div className="inline-flex">
                  <span className="px-3 py-1 rounded-full bg-[#EEF2FF] text-[#1D3FE8] text-xs font-medium font-[DM_Sans] tracking-wide">
                    {q.label}
                  </span>
                </div>

                {/* Quote */}
                <blockquote className="flex-1">
                  <p className="text-sm text-[#1A1A1A] font-[DM_Sans] leading-relaxed">
                    "{q.text}"
                  </p>
                </blockquote>

                {/* Attribution */}
                <div className="pt-4 border-t border-[#E2E8F0]">
                  <p className="font-semibold text-sm text-[#1A1A1A] font-[DM_Sans]">{q.person}</p>
                  <p className="text-xs text-[#888888] font-[DM_Sans] mt-0.5">{q.role}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
